"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var Icon_1 = require("../Icon");
var ExpandableContentGuts = (function (_super) {
    __extends(ExpandableContentGuts, _super);
    function ExpandableContentGuts(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleExpandableContent = _this.toggleExpandableContent.bind(_this);
        _this.state = {
            isOpen: false
        };
        return _this;
    }
    ExpandableContentGuts.prototype.render = function () {
        var _this = this;
        var iconStyle = this.state.isOpen ? 'down' : 'right';
        //Creates the right arrow icon for row expansion
        // tslint:disable-next-line:jsx-no-lambda
        var arrowElem = React.createElement("td", { className: 'expandedContentIcon', key: "row-" + (this.props.index + 1) + "-expand-icon", onClick: function () { return _this.toggleExpandableContent(); } },
            React.createElement(Icon_1.Icon, { icon: iconStyle }));
        var columnsArray = [arrowElem].concat(this.props.cols);
        var guts = this.state.isOpen ? this.renderGuts(this.props.content, this.props.row) : null;
        return (React.createElement(react_1.Fragment, { key: this.props.index },
            React.createElement("tr", { key: this.props.index }, columnsArray),
            guts));
    };
    ExpandableContentGuts.prototype.renderGuts = function (content, row) {
        var rendered = content(row);
        if (typeof rendered === 'string') {
            return React.createElement("tr", null,
                React.createElement("td", { style: { border: 'none' } }),
                React.createElement("td", { style: { border: 'none' }, colSpan: this.props.cols.length }, rendered));
        }
        return rendered;
    };
    ExpandableContentGuts.prototype.toggleExpandableContent = function () {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    return ExpandableContentGuts;
}(React.Component));
exports.ExpandableContentGuts = ExpandableContentGuts;
//# sourceMappingURL=ExpandableContentGuts.js.map